import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { SubNavProvider } from "./contexts/SubNavContext";
import Layout from "./Layout";
import Main from "./pages/Main";
import Company from "./pages/Company";
import People from "./pages/People";
import Business from "./pages/Business";
import Recruit from "./pages/Recruit";
import Contact from "./pages/Contact";
import Chat from "./pages/Chat";
import NewHome from "./pages/NewHome";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// ✅ 페이지 이동 시 스크롤을 최상단으로 이동시키는 컴포넌트
function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            {/* ✅ 라우터 안에 ScrollToTop 추가 */}
            <ScrollToTop />
            <SubNavProvider>
                <Routes>
                    <Route path="/" element={<NewHome />} />
                    <Route element={<Layout />}>
                        <Route path="/preview" element={<Main />} />
                        <Route path="/sub_company" element={<Company />} />
                        <Route path="/sub_people" element={<People />} />
                        <Route path="/sub_business" element={<Business />} />
                        <Route path="/sub_recruit" element={<Recruit />} />
                        <Route path="/sub_contact" element={<Contact />} />
                        <Route path="/sub_chat" element={<Chat />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </SubNavProvider>
        </BrowserRouter>
    );
}

export default App;
